import { Either, right, TaskEither, taskEither } from '@shared-commons/utils';
import { InstrumentArraySchema } from '../types/instrument';

const adaptInstrumentsOptions = async (
  input: InstrumentArraySchema,
): Promise<Either<Error, InstrumentArraySchema>> => {
  return right(input);
};

export const instrumentsAdapter = (
  input: InstrumentArraySchema,
): TaskEither<Error, InstrumentArraySchema> => {
  return taskEither(() => adaptInstrumentsOptions(input));
};
